export default "__VITE_ASSET__DbbmQJlI__"